"use strict";

export const init = () => {

    let attempts = 0;

    const whenComplete = () => {

        if(++attempts > 30)
            return;

        if(document.readyState === "complete")
            initBMI();
        else
            setTimeout(whenComplete, 400);
      
    };

    whenComplete();

};  

let dictionary = {
    obesityLevel5: 'Es besteht eine fortgeschrittene Adipositas. Es besteht möglicherweise eine Indikation zur metabolischen Chirurgie. Um weitere Details zu klären, verabreden Sie bitte einen Termin in unserer Sprechstunde unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a>. Wir beraten Sie gerne ausführlich.',
    obesityLevel4: 'Es besteht eine fortgeschrittene Adipositas. Es besteht möglicherweise die primäre Indikation zur bariatrischen Chirurgie, falls keine Kontraindikationen gegen einen solchen Eingriff vorliegen. Wir beraten Sie gerne ausführlich in unserer Sprechstunde. Bitte machen Sie einen Termin unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a> aus.',
    obesityLevel3: 'Es besteht eine fortgeschrittene Adipositas. Es ist möglich, dass bei Ihnen eine Indikation zur bariatrischen Chirurgie besteht. Vorher sollten jedoch auch die konservativen Möglichkeiten der Gewichtsreduktion ausgeschöpft werden. Hierfür sind mindestens sechs Beratungen bei einer zertifizierten Ernährungsberatung und zweimal wöchentlich Sport über mindestens sechs Monate notwendig. Lassen Sie sich auch von Ihrer Krankenkasse beraten. Konsultieren Sie Ihren Hausarzt, bevor Sie mit intensivem körperlichem Training beginnen. Wir beraten Sie gerne ausführlich in unserer Sprechstunde. Bitte machen Sie einen Termin unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a> aus.',
    obesityLevel2: 'Es besteht eine zweitgradige Adipositas. Es ist möglich, dass bei Ihnen eine Indikation zur metabolischen Chirurgie besteht. Vorher sollten jedoch auch die konservativen Möglichkeiten der Gewichtsreduktion ausgeschöpft werden. Hierfür sind mindestens sechs Beratungen bei einer zertifizierten Ernährungsberatung und zweimal wöchentlich Sport über mindestens sechs Monate notwendig. Lassen Sie sich auch von Ihrer Krankenkasse beraten. Konsultieren Sie Ihren Hausarzt, bevor Sie mit intensivem körperlichem Training beginnen. Wir beraten Sie gerne in unserer Sprechstunde. Bitte machen Sie einen Termin unter der Telefonnummer <a href="tel:071127862666">0711 278-62666</a> aus.',
    obesityLevel1: 'Es besteht eine Adipositas. Sie sollten zur Gewichtsreduktion eine zertifiziert Ernährungsberatung in Anspruch nehmen und mindestens zweimal pro Woche Sport treiben. Haben Sie schon über die Teilnahme an einem konservativ geführten Programm zur Gewichtsreduktion nachgedacht, so ist möglicherweise das Optifast Programm genau das Richtige. Nähere Informationen erhalten Sie unter Telefon <a href="tel:071145924895">0711 459-24895</a> oder <a href="mailto:info@zkes-optifast.de">info@zkes-optifast.de</a>. Eine Indikation zur bariatrischen Chirurgie besteht eher nicht.',
    overWeight: 'Sie sind übergewichtig oder leichtgradig adipös. Wir empfehlen Ihnen eine strukturierte Ernährungsberatung und ein Sportprogramm. Haben Sie schon über die Teilnahme an einem konservativ geführten Programm zur Gewichtsreduktion nachgedacht, so ist möglicherweise das Optifast Programm genau das Richtige.  Nähere Informationen erhalten Sie unter Telefon <a href="tel:071145924895">0711 459-24895</a> oder <a href="mailto:info@zkes-optifast.de">info@zkes-optifast.de</a>.',
    normalWeight: 'Sie haben Normalgewicht. Vermutlich ist keine ärztliche Intervention notwendig.',
    underWeight: 'Sie haben Untergewicht! Bitte sprechen sie mit Ihrem Hausarzt darüber und suchen sie weitere ärztliche Hilfe.',
}

function initBMI(){

    let formBmi = document.querySelector('.bmi_content');
    let inputHeight = formBmi.querySelector('.height');
    let inputWeight = formBmi.querySelector('.weight');
    let inputDiabetes = formBmi.querySelector('.diabetes');
    let btnCalculate = formBmi.querySelector('.calculate');
    let formResult = formBmi.querySelector('.output');
    let labelResultBMI = formBmi.querySelector('.resultbmi');
    let labelResult = formBmi.querySelector('.result');

    btnCalculate.addEventListener('click', () => {

        let height = parseFloat(inputHeight.value);
        let weight = parseFloat(inputWeight.value);
        let diabetes = inputDiabetes.value == 1;

        if(isNaN(height) || isNaN(weight)){

            labelResult.innerText = 'Bitte geben Sie eine gültige Größe und Gewicht ein.';
            formResult.classList.add('visible', 'error');

            return;

        }

        let bmi = weight / (height * height) * 10000;
        let resultText = '';

        if(diabetes){
            if(bmi >= 40)
                resultText = dictionary.obesityLevel5;
            else if(bmi >= 35 && bmi < 40)
                resultText = dictionary.obesityLevel2;
        }else{
            if(bmi >= 50)
                resultText = dictionary.obesityLevel4
            else if(bmi >= 35 && bmi < 50)
                resultText = dictionary.obesityLevel3;
        }

        if(bmi >= 30 && bmi < 35)
            resultText = dictionary.obesityLevel1;
		else if(bmi >= 25 && bmi < 30)
            resultText = dictionary.overWeight;
		else if(bmi > 18 && bmi < 25)
            resultText = dictionary.normalWeight;
		else if(bmi <= 18)
            resultText = dictionary.underWeight;

        labelResult.innerHTML = resultText;
        labelResultBMI.innerText = bmi.toFixed(2);
        formResult.classList.remove('error');
        formResult.classList.add('visible');

    });

}